<template>
  <li
    v-if="canLoadMore"
    ref="sentinelRef"
    class="flex h-8 items-center justify-center"
    data-cy="scroll-sentinel"
  >
    <loader v-if="isLoading" :is-loading="true" />
  </li>
</template>

<script setup lang="ts">
import { toRef, toValue, useTemplateRef } from "vue";

import { useInfiniteScrollSentinel } from "@/hooks/useInfiniteScrollSentinel";

import Loader from "@/components/ui/Loader.vue";

import type { MaybeRefOrGetter } from "vue";

const props = defineProps<{
  canLoadMore: boolean;
  isLoading: boolean;
  root?: MaybeRefOrGetter<HTMLElement | null>;
  rootMargin?: string;
}>();

const emit = defineEmits<{
  loadMore: [];
}>();

const sentinelRef = useTemplateRef<HTMLElement>("sentinelRef");

useInfiniteScrollSentinel({
  sentinel: sentinelRef,
  canLoadMore: toRef(() => props.canLoadMore),
  isLoading: toRef(() => props.isLoading),
  onLoadMore: () => emit("loadMore"),
  root: () => toValue(props.root) ?? null,
  rootMargin: props.rootMargin,
});
</script>
